/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Stream_FailedInputs */



/**
* | output |
* | --- |
* | "There was an error receiving the audio stream." |
*
* @param {Audio_Description_Export_Audio_Stream_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_stream_failed = /** @type {((inputs?: Audio_Description_Export_Audio_Stream_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Stream_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur est survenue lors de la réception du flux audio.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Empfang des Audiostreams ist ein Fehler aufgetreten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore durante la ricezione del flusso audio.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка при приеме аудиопотока.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se produjo un error al recibir la transmisión de audio.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("接收音频流时出错。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ ストリームの受信中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो स्ट्रीम प्राप्त करने में त्रुटि हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro ao receber o fluxo de áudio.")
	return /** @type {LocalizedString} */ ("There was an error receiving the audio stream.")
});